module.exports = ".SelectFirm_add-new {\n  color: #90B9ED;\n  font-weight: bold;\n  text-transform: uppercase; }\n"